// list of available site content (aka content overrides)

// site-wide
export const SITE_CONTACT_INFO = 'site.contact-info.json'
export const SITE_SCRIPTS = 'site.scripts.json'

// auth
export const AUTH_LOGIN_NOTIFICATION = 'auth.login.notification.html'

// companies
export const COMPANIES_DASHBOARD_CONFIG = 'companies.dashboard.datagrid.config.json'
export const COMPANIES_HISTORY_CONFIG = 'companies.history.datagrid.config.json'
export const COMPANIES_MEMBERS_CONFIG = 'companies.members.datagrid.config.json'

// contacts
export const CONTACTS_DASHBOARD_CONFIG = 'contacts.dashboard.datagrid.config.json'

// contacts
export const CYCLES_PHASE_DETAILS_CONFIG = 'cycles.phase.details.config.json'
export const CYCLES_PHASE_DETAILS_PROJECTS_DATAGRID_CONFIG = 'cycles.phase.details.projects.datagrid.config.json'
export const CYCLES_PHASE_DETAILS_TASKS_DATAGRID_CONFIG = 'cycles.phase.details.tasks.datagrid.config.json'

// deadlines
export const DEADLINES_DEFINITIONS_CONFIG = 'deadlines.definitions.datagrid.config.json'
export const DEADLINES_HISTORY_CONFIG = 'deadlines.history.datagrid.config.json'
export const DEADLINES_INSTANCES_CONFIG = 'deadlines.instances.datagrid.config.json'

// projects
export const PROJECTS_DASHBOARD_CONFIG = 'projects.dashboard.config.json'
export const PROJECTS_DASHBOARD_NOTIFICATION = 'projects.dashboard.notification.html'
export const PROJECTS_DASHBOARD_START_NEW_PROJECTS = 'projects.dashboard.start-new-projects.html'
export const PROJECTS_DETAILS_CONFIG = 'projects.details.config.json'
export const PROJECTS_DETAILS_NOTIFICATION = 'projects.details.notification.html'
export const PROJECTS_QUEUE_CONFIG = 'projects.queue.config.json'
export const PROJECTS_QUEUE_DATAGRID_CONFIG = 'projects.queue.datagrid.config.json'
